import styled from 'styled-components';
import withColor from 'util/hoc/with-color';

import { BaseFormElementStyle } from 'library/components/form-components/base-form-element-style';

const StyledDropdownContainer = withColor(styled.div`
  ${BaseFormElementStyle}
  cursor: pointer;
  border-radius: 4px 4px 0 0;
  width: 100%;
  padding: unset;

  &:hover,
  &:focus {
    border-color: #207c9d;
  }
  ${(props) =>
    props.compact
      ? `
    height: 2.5em;
    > div {
      padding: 0.45em;
    }
    > span div {
      padding: 0.75em 1.7em;
    }
    @media (max-width: 768px) {
      > span div {
        display: none;
      }
    }
  `
      : ``}

  &:disabled {
    border: 1px solid ${(props) => props.theme.colors.grey300};
    cursor: not-allowed;
  }
`);

const StyledDropdown = withColor(styled.div`
  padding: ${(props) => (props.placeholderOnly ? '0' : '0.75em 0.75em 0.5em')};
  width: 100%;
  font-size: 1em;

  > svg {
    margin-right: 0.5em;
  }
  > span {
    font-weight: 700;
  }
`);

const StyledDropdownLabel = withColor(styled.label`
  color: ${(props) => props.colors.grey1};
  background: white;
  display: flex;
  position: absolute;
  top: -0.7rem;
  left: 0.65rem;
  padding: 0 0.25em;
  transition: all 0.125s ease-in-out;
  justify-content: space-between;
  font-size: 0.825em;
`);

const StyledDropdownDescription = withColor(styled.div`
  display: flex;
  padding: 1em 1em 0.5em;
  justify-content: center;
`);

const StyledIcon = styled.span`
  position: absolute;
  margin-right: -0.75em;
  right: -0.5em;
  top: -0.75em;
  font-size: 1em;
  font-weight: 400;
  transition: all 0.125s ease-in-out;
  transform: translateY(${(props) => (props.active ? '0' : '.75rem')});
  margin: unset;
  color: rgba(0, 0, 0, 0.6);
`;

const StyledDropdownContent = withColor(styled.div`
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border: 1px solid #207c9d;
  background: white;
  flex-direction: column;
  position: absolute;
  width: 100%;
  z-index: 2;
  ${(props) => (props.compact ? `top: 2.4em;` : `top: 2.9em;`)}
  left: 0;
  overflow-y: auto;
  max-height: 666px;
  box-shadow: 1px 4px 10px 0 rgba(0, 0, 0, 0.1),
    1px 6px 10px 0 rgba(0, 0, 0, 0.12);

  svg {
    pointer-events: none;
  }
  ${(props) => props.hide && 'display: none!important;'}
`);

const StyledOption = styled.option`
  cursor: pointer;
  padding: 1em;
  transition: all 0.125s ease-in-out;
  display: flex;
  ${(props) => (props.isTabbing ? `` : `outline: none;`)}
  font-size: ${(props) => (props.isNestedChild ? `0.825em` : `1em`)};

  > :last-child {
    flex: 1;
    padding-left: 0.5em;
  }

  &:hover {
    background: #F0F0F0;
  }
`;

const StyledBox = withColor(styled.div`
  background: ${(props) => (props.active ? '#207C9D' : `#FFF`)};
  text-align: center;
  color: #207c9d;
  width: 18px;
  height: 18px;
  margin: auto;
  display: flex;
  border: 1px solid;
  border-radius: 3px;
  transition: all 0.2s ease-in-out;
  font-size: 1em;

  span {
    width: 100%;
    height: 100%;
    font-weight: bold;
  }
`);

export {
  StyledDropdownContainer,
  StyledDropdown,
  StyledIcon,
  StyledDropdownContent,
  StyledOption,
  StyledBox,
  StyledDropdownLabel,
  StyledDropdownDescription,
};
